import { render, staticRenderFns } from "./MarketActivityRuleModal.vue?vue&type=template&id=2de1f9b4&scoped=true&"
import script from "./MarketActivityRuleModal.vue?vue&type=script&lang=js&"
export * from "./MarketActivityRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1f9b4",
  null
  
)

export default component.exports